import {omit, difference, keys, keyBy, createReducer, Base64} from 'helpers';
import * as actions from './actions';
import {RootState, Actions} from 'store/types';
import {ServerActions} from 'store/server';

export const units = createReducer<RootState['units'], Actions<typeof actions> | ServerActions>({}, {
  UNIT_UPSERT(state, {unit}) {
    if (unit) {
      return {
        ...state,
        [unit.serverId]: unit
      }
    }
    return state;
  },

  UNIT_RENAME(state, {id, name}) {
    const unit = state[id];
    if (unit) {
      return {
        ...state,
        [unit.serverId]: {
          ...unit,
          name
        }
      }
    }
    return state;
  },

  UNIT_REMOVE(state, {ids}) {
    return omit(state, ids);
  },

  SERVER_DATA_RECEIVED(state, action) {
    const removed = difference(keys(state), action.existingElementIds.units);
    if (action.units.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.units.map((unit) => ({
          category: unit.category,
          isDefault: unit.isDefault,
          orderIndex: unit.orderIndex,
          serverId: unit.serverId,
          name: Base64.decode(unit.name)
        })), 'serverId'),
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: () => ({}),
});
